import { useMemo } from 'react';
import { FancySharePublicDto } from '@diritto/common/fancyShare/dtos/fancy-share.dtos';
import { usePostRelayProfilesQuery } from 'queries/relay/usePostRelayProfilesQuery';
import { usePostRelayContentsQuery } from 'queries/relay/usePostRelayContentsQuery';
import { usePostRelayEpisodesQuery } from 'queries/relay/usePostRelayEpisodesQuery';
import { useGetLikedFancySharesQuery } from 'queries/fancyShare/useGetLikedFancySharesQuery';
import { useAuthState } from 'contexts/AuthProvider';
import { RelayType } from '@diritto/common/content/constants';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { removeNull } from '@diritto/common/utils/array';

export const useFancyShareExtra = (fancyShares: FancySharePublicDto[]) => {
  const { includeAdult } = useAuthState();

  // TODO : likeFancyShareIds 처럼 새로운것만 하도록 정리해야 한다. 그런데 마지막꺼만 갱신하면 되나? fancySharesQuery.refetch(); 와 연관도 있다.
  const { data: contentRelayData, isPending: isContentPending } = usePostRelayContentsQuery({
    contentIds: fancyShares.map(fancyShare => fancyShare.contentId),
    includeAdult,
  });

  const { data: profileRelayData, isPending: isProfilePending } = usePostRelayProfilesQuery(
    fancyShares.map(fancyShare => fancyShare.profileId),
  );

  const { data: authorProfileRelayData, isPending: isAuthorProfilePending } = usePostRelayProfilesQuery(
    removeNull(
      Object.keys(contentRelayData?.contents ?? {})
        .filter(contentId => contentRelayData?.contents[contentId]?.relayType === RelayType.Public)
        .map(contentId => (contentRelayData?.contents[contentId] as ContentPublicRelayDto).profileId),
    ),
  );

  const { data: episodeRelayData, isPending: isEpisodePending } = usePostRelayEpisodesQuery({
    episodeIds: fancyShares.map(fancyShare => fancyShare.episodeId),
  });

  // Like
  const { data: likeData } = useGetLikedFancySharesQuery(fancyShares.map(fancyShare => fancyShare.id));

  return useMemo(
    () => ({
      isPending: isProfilePending || isContentPending || isEpisodePending || isAuthorProfilePending,
      fancyShares,
      profiles: { ...(profileRelayData?.profiles ?? {}), ...(authorProfileRelayData?.profiles ?? {}) },
      contents: contentRelayData?.contents ?? {},
      episodes: episodeRelayData?.episodes ?? {},
      likeFancyShareIds: likeData?.likeFancyShareIds ?? [],
    }),
    [
      authorProfileRelayData?.profiles,
      contentRelayData?.contents,
      episodeRelayData?.episodes,
      fancyShares,
      isAuthorProfilePending,
      isContentPending,
      isEpisodePending,
      isProfilePending,
      likeData?.likeFancyShareIds,
      profileRelayData?.profiles,
    ],
  );
};
